import { useEffect } from 'react'
import { atom, useRecoilState } from 'recoil'
import { getRequest } from '/src/httpClient'

import { userStoreState } from '../components/commerce/store/storeSelectorState'

/*export const storeState = atom({
  key: 'storeState',
  default: false
})*/

// @deprecated?
export const useStore = () => {
  const [results, setResults] = useRecoilState(userStoreState)

  useEffect(() => {
    if (!results) return
    const controller = new AbortController();

    (async () => {
      const response = await getRequest('/api/store', controller)
      setResults(response)
    })()

    return () => controller.abort()
  }, [])

  return results
}
